export default __webpack_public_path__ + "static/media/raute-tracks.3cae60a9.jpg";